import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { useRef, useEffect } from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import { FocusTrap } from './FocusTrap.js';
import { useInertA11yBackground } from '../../hooks/useInertA11yBackground.js';
import { useForceUpdate } from '../../hooks/useForceUpdate.js';
import { jsx } from '@emotion/react';
import 'react-focus-lock';

/**
 * @see https://experience.indeed.design/components/ids/accessible-trap
 */
const AccessibleTrap = props => {
  const focusTrapRef = useRef(null);
  const forceUpdate = useForceUpdate();
  const {
    disabled = false,
    allowPinchZoom = false,
    disableScroll = true,
    hideBackground = true,
    focusWrapperStyle,
    children,
    ...focusTrapProps
  } = props;
  const hiddenBackgroundRoot = typeof hideBackground === "object" ? hideBackground.root ?? document.body : document.body;
  const hiddenBackgroundAllowList = typeof hideBackground === "object" ? hideBackground.allowList ?? [] : [];
  useInertA11yBackground(!disabled && !!hideBackground, [focusTrapRef, ...hiddenBackgroundAllowList], hiddenBackgroundRoot);

  /**
   * There is an issue where Reach UI portal refs' `current` property is always
   * null, thus being hidden via our `useInertA11yBackground` hook. This forces
   * a render so those refs are no longer null and their respective elements
   * aren't hidden.
   *
   * See if this can be removed.
   */
  useEffect(() => {
    forceUpdate();
  }, [forceUpdate]);
  return jsx(FocusTrap, _extends({
    ref: focusTrapRef,
    disabled: disabled,
    allowFocusList: hiddenBackgroundAllowList,
    style: focusWrapperStyle
  }, focusTrapProps), !disabled && disableScroll ? jsx(RemoveScroll, {
    allowPinchZoom: allowPinchZoom
  }, children) : children);
};
AccessibleTrap.displayName = "AccessibleTrap";

/**
 * Use this CSS class name on the visible elements with the CSS `position: fixed`
 * to prevent the UI shifts when the trap is activated.
 */
const AccessibleTrapFixedClassName = RemoveScroll.classNames.zeroRight;

export { AccessibleTrap, AccessibleTrapFixedClassName };
